import { fetchDataFromPresignedURLEpic } from './fetchDataFromPresignedURLEpic';
import { generateReportAsyncEpic } from './generateReportAsyncEpic';
import generatePresignedUrlEpic from './getDDUOptionsEpic';

export const generateReportEpics = [
  generateReportAsyncEpic,
  generatePresignedUrlEpic,
  fetchDataFromPresignedURLEpic,
];

export default generateReportEpics;